export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  // Mensaje nuevo en una conversación · lo usa el Kanban de Leads para refrescar
  // el preview "el cliente escribió" en la tarjeta en tiempo real (Victor 2026-05-25).
  NEW_MESSAGE_FOR_DEAL: 'NEW_MESSAGE_FOR_DEAL',
  CONVERSATION_UPDATED_FOR_DEAL: 'CONVERSATION_UPDATED_FOR_DEAL',
  // Tarea asignada en vivo · dispara modal centrado + sonido + refresh campana.
  TASK_ASSIGNED_LIVE: 'TASK_ASSIGNED_LIVE',
  // Tarea completada por el agente (por confirmar) · banner central + campana
  // verde para que quien la asignó la confirme (Victor 2026-06-04).
  TASK_COMPLETED_LIVE: 'TASK_COMPLETED_LIVE',
  // Lead cambió de etapa/embudo en vivo · el panel del lead actualiza la barra
  // de etapa al instante para todos los que ven ese cliente (Victor 2026-06-08).
  DEAL_UPDATED_LIVE: 'DEAL_UPDATED_LIVE',
};
